import * as React from "react";
import { Text, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    display: "flex",
    gap: "8px",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  titleWrap: {
    display: "grid",
    gap: "2px",
    minWidth: 0,
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    minWidth: 0,
  },
  subtitle: {
    color: "var(--colorNeutralForeground3)",
  },
  actions: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
    flexWrap: "wrap",
  },
});

export interface SectionHeaderControlProps {
  title: React.ReactNode;
  titleLeading?: React.ReactNode;
  titleActions?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export function SectionHeaderControl({ title, titleLeading, titleActions, subtitle, actions }: SectionHeaderControlProps): JSX.Element {
  const styles = useStyles();
  const renderedTitle = typeof title === "string" ? <Text weight="semibold">{title}</Text> : title;

  return (
    <div className={styles.root}>
      <div className={styles.titleWrap}>
        <div className={styles.titleRow}>
          {titleLeading}
          {renderedTitle}
          {titleActions}
        </div>
        {subtitle ? <Text className={styles.subtitle}>{subtitle}</Text> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}